import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { HiCheckCircle, HiDocumentText, HiEye, HiSquares2X2 } from "react-icons/hi2";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import MainButton, {
  BackButton,
  ViewButton,
} from "../../components/common/MainButtonComponent";
import { routes } from "../../helper/routes";
import Filter from "./Filter";
import { getAllQuestionsForAddQuestionInSetupWithFilter } from "../../service/assessSections/assessSectionsService/assessSectionsService";
import AssessmentPagination from "./AssessmentPagination";
import "./SetupAssessmentAddQuestionsPage.css";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SetupAssessmentQuestionViewPage from "./SetupAssessmentQuestionViewPage";
import { addQuestionsToAssessmentSetup } from "../../service/assessSections/assessSectionsService/assessSectionsService";
import { sweetSuccessAlert, sweetErrorAlert,sweetConfirmAlert } from "../../components/common/SweetAlert";
import { use } from "react";

const addQuestionFilterConfig = [
  { key: "grade", label: "Grade", icon: HiSquares2X2, optionKey: "gradeOptions" },
  { key: "language", label: "Language", icon: HiSquares2X2, optionKey: "languageOptions" },
  { key: "subject", label: "Subject", icon: HiSquares2X2, optionKey: "subjectOptions" },
  { key: "term", label: "Term", icon: HiSquares2X2, optionKey: "termOptions" },
  { key: "author", label: "Author", icon: HiSquares2X2, optionKey: "authorOptions" },
  { key: "chapter", label: "Chapter", icon: HiSquares2X2, optionKey: "chapterOptions" },
  { key: "difficulty", label: "Difficulty", icon: HiSquares2X2, optionKey: "difficultyOptions" },
  { key: "type", label: "Type", icon: HiSquares2X2, optionKey: "typeOptions" },
  { key: "examCategory", label: "Exam Category", icon: HiSquares2X2, optionKey: "examCategoryOptions" },
  { key: "source", label: "Source", icon: HiSquares2X2, optionKey: "sourceOptions" },
  { key: "createdBy", label: "Created By", icon: HiSquares2X2, optionKey: "createdByOptions" },
  { key: "year", label: "Year", icon: HiSquares2X2, optionKey: "yearOptions" },
];

const difficultyToneClassMap = {
  Hard: "setup-add-question-card__badge--hard",
  Medium: "setup-add-question-card__badge--medium",
  Easy: "setup-add-question-card__badge--easy",
  "N/A": "setup-add-question-card__badge--neutral",
};

const toArray = (value) => {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value.filter(Boolean) : [value].filter(Boolean);
};

const getOptionLabel = (options, value, fallback = "N/A") => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const match = (options || []).find((option) => String(option.value) === String(value));
  return match?.label ?? String(value);
};



const mapApiQuestionToViewModel = (question, metadataOptions = {}) => {
  const subQuestions = toArray(
    typeof question.sub_questions === "string"
      ? question.sub_questions.split(",")
      : question.sub_questions
  );
  
  return {
    id: String(question.question_id),
    code: question.code || `QUSTN${question.question_id}`,
    name:
      question.title ||
      question.name ||
      `Question ${question.question_id}`,
    createdAt: question.created_at || "N/A",
    questions: subQuestions.length,
    owner: question.category_id ? `Category ${question.category_id}` : "N/A",
    type: question.question_type_name || "N/A",
    status: question.is_subquestion ? "Sub Question" : "N/A",
    difficulty: getOptionLabel(metadataOptions.difficultyOptions, question.difficulty_id),
    grade: getOptionLabel(metadataOptions.gradeOptions, question.grade_id),
    language: getOptionLabel(metadataOptions.languageOptions, question.language_id),
    subject: getOptionLabel(metadataOptions.subjectOptions, question.subject_id),
    term: getOptionLabel(metadataOptions.termOptions, question.term_id),
    author: getOptionLabel(metadataOptions.authorOptions, question.author_id),
    chapter: getOptionLabel(metadataOptions.chapterOptions, question.chapter_id),
    examCategory: getOptionLabel(metadataOptions.examCategoryOptions, question.category_id),
    source: getOptionLabel(metadataOptions.sourceOptions, question.source_id),
    createdBy: getOptionLabel(metadataOptions.createdByOptions, question.created_by),
    year: getOptionLabel(metadataOptions.yearOptions, question.year_id),

    answer: question.answer || "N/A",
    answer_type_id: question.answer_type_id || null,
    content: question.content || "N/A",
    is_subquestion: question.is_subquestion || false,
    sub_questions: subQuestions,
    sub_questions_details: question.sub_questions_details || [],


  };
};


export default function SetupAssessmentAddQuestionsPage({metadataOptions,setOpenAddQuestion,assessmentId,addedQuestions}) {
  const history = useHistory();
  const { id } = useParams();
  const [FilterOption, setFilterOption] = useState({
    limit: 20,
    offset: 0,
    sort_column: "created_at",
    sort_direction: "DESC",
    search_term: "",
    selectedAuthors: [],
    selectedChapters: [],
    selectedGrades: [],
    selectedDifficulties: [],
    selectedLanguages: [],
    selectedTerms: [],
    selectedYears: [],
    selectedsubjects: [],
    selectedTypes: [],
    selectedExamCategories: [],
    selectedSources: [],
    selectedCreators: [],
    selectedStartDate: null,
    selectedEndDate: null,
  });
  const [selectedQuestionsDetails, setSelectedQuestionsDetails] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [questionsError, setQuestionsError] = useState(null);
  const [isAddingQuestions, setIsAddingQuestions] = useState(false);


  useEffect(() => {
  console.log("question ",questions);
  // console.log("metadata options ",metadataOptions);
  }, [questions,metadataOptions]);
//-------------------------------------
//metadata option
//--------------------------------------
  //  const location = useLocation();
  // const metadataOptions = location.state?.metadataOptions ?? location.state?.metaDataOptions;

  useEffect(() => {
    let isActive = true;

    const fetchQuestions = async () => {
      try {
        setIsLoadingQuestions(true);
        setQuestionsError(null);

        const response = await getAllQuestionsForAddQuestionInSetupWithFilter({
          params: FilterOption,
          assessmentId,
        });

        const questionRows = response?.data?.questions ?? response?.questions ?? [];
        const total = response?.data?.total_all_count ?? response?.total_all_count ?? 0;
        const mappedQuestions = questionRows.map((question) =>
          mapApiQuestionToViewModel(question, metadataOptions)
        );

        if (isActive) {
          setTotalCount(total);
          setQuestions(mappedQuestions);
        }
      } catch (error) {
        if (isActive) {
          setQuestions([]);
          setQuestionsError(error);
        }
      } finally {
        if (isActive) {
          setIsLoadingQuestions(false);
        }
      }
    };

    fetchQuestions();

    return () => {
      isActive = false;
    };
  }, [FilterOption, metadataOptions, assessmentId]);

//-----------------------------------------
// Label for selected count (No questions selected Showing 20 questions)
//-----------------------------------------
  const selectedCountLabel = useMemo(() => {
    if (!selectedQuestionsDetails.length) return "No questions selected";
    if (selectedQuestionsDetails.length === 1) return "1 question selected";
    return `${selectedQuestionsDetails.length} questions selected`;
  }, [selectedQuestionsDetails.length]);

//-----------------------------------------
// Toggle selection of a single question
//-----------------------------------------
  const toggleQuestionSelection = (question) => {
    setSelectedQuestionsDetails((previousQuestions) =>
      previousQuestions.some((item) => item.id === question.id)
        ? previousQuestions.filter((item) => item.id !== question.id)
        : [...previousQuestions, question]
    );
  };

  useEffect(() => {
    console.log("Selected questions details updated:", selectedQuestionsDetails);
  }, [selectedQuestionsDetails]);

//-----------------------------------------
// Determine if all questions are selected
//-----------------------------------------
  const areAllVisibleSelected =
    questions.length > 0 &&
    questions.every((question) =>
      selectedQuestionsDetails.some((item) => item.id === question.id)
    );
  const toggleSelectAllVisible = () => {
    setSelectedQuestionsDetails((currentQuestions) => {
      if (areAllVisibleSelected) {
        return currentQuestions.filter(
          (question) =>
            !questions.some((visibleQuestion) => visibleQuestion.id === question.id)
        );
      }

      const nextQuestions = [...currentQuestions];
      questions.forEach((question) => {
        if (!nextQuestions.some((item) => item.id === question.id)) {
          nextQuestions.push(question);
        }
      });
      return nextQuestions;
    });
  };

//-----------------------------------------
// Handlers for pagination controls
//-----------------------------------------
  const currentPage = Math.floor(FilterOption.offset / FilterOption.limit) + 1;
  const handlePageChange = (nextPage) => {
    setFilterOption((current) => ({
      ...current,
      offset: (nextPage - 1) * current.limit,
    }));
  };

  const handlePageSizeChange = (nextPageSize) => {
    setFilterOption((current) => ({
      ...current,
      limit: nextPageSize,
      offset: 0,
    }));
  };

//-----------------------------------------
// Navigate back to setup page
//-----------------------------------------
  const goBackToSetup = () => {
     setOpenAddQuestion(false);
    // history.push(`${routes.asses_lib}/setup/${id}`);
  };

//-----------------------------------------
// Handle adding selected questions and navigating back to setup page with selected question IDs in state
//-----------------------------------------

  const handleAddSelectedQuestions = async () => {

    setIsAddingQuestions(true);
    const buildAssessmentQuestionPayloadRows = (question, assessmentId, addedBy) => {
              const basePayload = {
                assessment_id: Number(assessmentId),
                question_id: Number(question.id),
                added_by: addedBy,
              };

              const subQuestionIds = [
                ...(Array.isArray(question.sub_questions) ? question.sub_questions : []),
                ...(Array.isArray(question.sub_questions_details)
                  ? question.sub_questions_details.map((subQuestion) => subQuestion?.question_id)
                  : []),
              ]
                .map((subQuestionId) => Number(subQuestionId))
                .filter((subQuestionId) => Number.isFinite(subQuestionId));

              const uniqueSubQuestionIds = [...new Set(subQuestionIds)].filter(
                (subQuestionId) => subQuestionId !== basePayload.question_id
              );

              return [
                basePayload,
                ...uniqueSubQuestionIds.map((subQuestionId) => ({
                  assessment_id: basePayload.assessment_id,
                  question_id: subQuestionId,
                  added_by: addedBy,
                })),
              ];
            };
      const addedBy =
        sessionStorage.getItem("employeeType") + sessionStorage.getItem("user_id");
      const questionsData = selectedQuestionsDetails.flatMap((question) =>
        buildAssessmentQuestionPayloadRows(question, assessmentId ?? id, addedBy)
      );

    try {
      const result = await addQuestionsToAssessmentSetup(questionsData);
      if (result && result.success) {
        if (typeof addedQuestions === "function") {
          addedQuestions(selectedQuestionsDetails);
        }
        setOpenAddQuestion(false);
        sweetSuccessAlert("Questions added to setup successfully");
      } else {
        sweetErrorAlert("Failed to add questions to setup. Please try again.");
      }
    } catch (error) {
      sweetErrorAlert("Failed to add questions to setup. Please try again.");
    } finally {
      setIsAddingQuestions(false);
    }
    // history.push({
    //   pathname: `${routes.asses_lib}/setup/${id}`,
    //   state: {
    //     setupQuestionPicker: {
    //       selectedQuestionsDetails,
    //     },
    //   },
    // });
  };

//-----------------------------------------
// Navigate to question view page//////-----------------@@@@@@@@@@---------------------
//-----------------------------------------
const [DetailsViewQuestion, setDetailsViewQuestion] = useState(null);
const [openQuestionView, setOpenQuestionView] = useState(false);
  const goToQuestionView = (question) => {
    setDetailsViewQuestion(question);
    setOpenQuestionView(true);


    // history.push({
    //   pathname: routes.ques_lib_view.replace(":id", question.id),
    //   state: {
    //     backTo: routes.asses_lib_setup_add_questions.replace(":id", id),
    //     backLabel: "Back to Question Select",
    //     question: question,
    //   },
    // });


  };

//-----------------------------------------
// Return the JSX for the component
//-----------------------------------------
  return (

    openQuestionView && DetailsViewQuestion ? (

      //-----------------------------
      // Show question detail view if a question is selected for viewing
      //-----------------------------
      <SetupAssessmentQuestionViewPage 
        question={DetailsViewQuestion}
        backLabel="Back to Question Select"
        setOpenQuestionView={() => setOpenQuestionView(false)}
       />

    ) : (

      <ContentWrapper>
      <section className="setup-add-questions-page assess-section">
        <div>
        <div className="setup-add-questions-page__topbar">
          <BackButton label="Back" onClick={goBackToSetup} />
          <div className="setup-add-questions-page__spacer" />
          <MainButton
            action="add"
            icon="add"
            label={
              isAddingQuestions
                ? `Adding Questions${
                    selectedQuestionsDetails.length ? ` (${selectedQuestionsDetails.length})` : ""
                  }`
                : `Add Selected Questions${
                    selectedQuestionsDetails.length ? ` (${selectedQuestionsDetails.length})` : ""
                  }`
            }
            tone="success"
            disabled={!selectedQuestionsDetails.length || isAddingQuestions}
            className="setup-add-questions-page__add-btn"
            onClick={handleAddSelectedQuestions}
          />
        </div>


        {/* //-----------------------------
        // Filter component for refining question list
        //----------------------------- */}
        <Filter 
          metaDataOptions={metadataOptions} 
          onQueryChange={setFilterOption}
          apiFilters={FilterOption}
          syncKey={`assessment-setup-add-questions:${assessmentId ?? id}`}
          count = {totalCount}
          countLabel = "Number of Questions "
          searchAriaLabel="Search questions"
          filterConfigOverride={addQuestionFilterConfig}
          extraInitialFilters={{ type: [] }}
         />

        <div className="setup-add-questions-page__list-head">
          <button
            type="button"
            className={`setup-add-select-all ${
              areAllVisibleSelected ? "setup-add-select-all--active" : ""
            }`}
            onClick={toggleSelectAllVisible}
          >
            <span className="setup-add-select-all__checkbox">
              {areAllVisibleSelected ? <HiCheckCircle aria-hidden="true" /> : null}
            </span>
            <span>Select all questions</span>
          </button>

          {/* <div className="setup-add-questions-page__summary">
            <span>{selectedCountLabel}</span>
            <span>
              Showing <strong>{questions.length}</strong> questions
            </span>
          </div> */}
        </div>
       </div>

        {/* //-----------------------------
        // Render the list of questions or appropriate messages based on loading/error state
        //----------------------------- */}

        <div className="setup-add-question-list">
          {isLoadingQuestions ? (
            <div className="setup-add-questions-page__empty">
              <h3>Loading questions</h3>
              <p>Fetching questions from the assessment library.</p>
            </div>
          ) : questionsError ? (
            <div className="setup-add-questions-page__empty">
              <h3>Unable to load questions</h3>
              <p>Please try again after checking the assessment API response.</p>
            </div>
          ) : questions.map((question) => {
            const isSelected = selectedQuestionsDetails.some(
              (item) => item.id === question.id
            );
            const difficultyClassName =
              difficultyToneClassMap[question.difficulty] ||
              "setup-add-question-card__badge--neutral";

            return (
              <article
                className={`setup-add-question-card ${
                  isSelected ? "setup-add-question-card--selected" : ""
                }`}
                key={question.id}
              >
                <div className="row g-3 align-items-center">
                  <div className="col-12 col-xl-8">
                    <div className="setup-add-question-card__main">
                      <label className="setup-add-question-card__checkbox">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => toggleQuestionSelection(question)}
                          aria-label={`Select ${question.name}`}
                        />
                        <span />
                      </label>

                      <div className="setup-add-question-card__icon">
                        <HiDocumentText aria-hidden="true" />
                      </div>

                      <div className="setup-add-question-card__content">
                        <div className="setup-add-question-card__title-row">
                          <span className="setup-add-question-card__code">
                            QUSTN{question.id || "N/A"}
                          </span>
                          <span
                            className={`setup-add-question-card__badge ${difficultyClassName}`}
                          >
                            {question.difficulty || "N/A"}
                          </span>
                        </div>

                        <h3>{question.name}</h3>

                        <div className="setup-add-question-card__meta">
                          <span>
                            <HiSquares2X2 aria-hidden="true" />
                            {question.owner || "N/A"}
                          </span>
                          <span>{question.type || "N/A"}</span>
                          <span>{question.subject || "N/A"}</span>
                          <span>{question.grade || "N/A"}</span>
                          <span>{question.language || "N/A"}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-xl-4">
                    <div className="setup-add-question-card__side">
                      <div className="setup-add-question-card__stats">
                        {question.questions > 0 && (
                        <div>
                         <span>Questions</span>
                          <strong>{question.questions || 0}</strong>
                        </div>
                         ) }
                        {/* <div>
                          <span>Created</span>
                          <strong>{question.createdAt ? new Date(question.createdAt).toLocaleDateString() : "N/A"}</strong>
                        </div> */}
                      </div>

                      <div className="setup-add-question-card__actions">
                        <ViewButton
                          label=""
                          title="View question"
                          aria-label={`View ${question.name}`}
                          onClick={(e) => goToQuestionView(question)}
                        />
                        {/* <MainButton
                          action={isSelected ? "save" : "add"}
                          icon={isSelected ? "save" : "add"}
                          label={isSelected ? "Selected" : "Select"}
                          tone={isSelected ? "success" : "primary"}
                          onClick={() => toggleQuestionSelection(question)}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {/* //-----------------------------
        // Show message if there are no questions to display (after loading and if no error)
        //----------------------------- */}

        {!questions.length ? (
          <div className="setup-add-questions-page__empty">
            <div className="setup-add-questions-page__empty-icon">
              <HiEye aria-hidden="true" />
            </div>
            <h3>No questions found</h3>
            <p>Adjust the filters or search to find matching questions.</p>
          </div>
        ) : null}

        {/* //-----------------------------
        // Render pagination controls
        //----------------------------- */}

        <AssessmentPagination
          page={currentPage}
          pageSize={FilterOption.limit}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      </section>
   
      </ContentWrapper>
    
  )
  );
}
